import React, { Component } from "react";
import reactCSS from "reactcss";
import PropTypes from "prop-types";

import TextField from "../text-field";
import Autosuggest from "react-autosuggest";

import "../index.css";
import "./auto-complete.css";

class AutoComplete extends Component {
  static defaultProps = {
    label: "",
    options: [],
    value: "",
    fullWidth: false,
    onSelect: () => {},
    onChange: () => {},
    errorText: ""
  };

  static propTypes = {
    label: PropTypes.string,
    options: PropTypes.array,
    value: PropTypes.string,
    fullWidth: PropTypes.bool,
    onSelect: PropTypes.func,
    onChange: PropTypes.func,
    errorText: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value,
      suggestions: this.props.options,
      renderSuggestions: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value && !!nextProps.value) {
      this.setValue(nextProps.value);
    }
  }

  setRenderSuggestions = value => {
    this.setState({ renderSuggestions: value });
  };

  getSuggestions = value => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    const response =
      inputLength === 0
        ? []
        : this.props.options.filter(
            option =>
              option.name.toLowerCase().slice(0, inputLength) === inputValue
          );
    return response;
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value)
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  getSuggestionValue = suggestion => suggestion.name;

  renderSuggestion = suggestion => <div>{suggestion.name}</div>;

  setValue = value => {
    this.setState({
      value
    });
  };

  onChange = (event, params) => {
    this.props.onChange(event, params.newValue);
    this.setValue(params.newValue);
  };

  inputProps = () => {
    return {
      label: this.props.label,
      value: this.state.value,
      fullWidth: this.props.fullWidth,
      errorText: this.props.errorText,
      onChange: this.onChange,
      onFocus: () => this.setRenderSuggestions(true)
      //onBlur: () => this.setRenderSuggestions(false),
    };
  };

  renderInputComponent = inputProps => (
    <div className="autocomplete--textfield">
      <TextField {...inputProps} refCallback={inputProps.ref} ref={null} />
    </div>
  );

  onSuggestionSelected = (event, params) => {
    this.props.onSelect(params);
    this.setRenderSuggestions(false);
  };

  theme = () => {
    return {
      container: "react-autosuggest__container",
      containerOpen: "react-autosuggest__container--open",
      input: "react-autosuggest__input",
      inputOpen: "react-autosuggest__input--open",
      inputFocused: "react-autosuggest__input--focused",
      suggestionsContainer: "react-autosuggest__suggestions-container",
      suggestionsContainerOpen: this.props.fullWidth
        ? "react-autosuggest__suggestions-container--open__full-width"
        : "react-autosuggest__suggestions-container--open",
      suggestionsList: "react-autosuggest__suggestions-list",
      suggestion: "react-autosuggest__suggestion",
      suggestionFirst: "react-autosuggest__suggestion--first",
      suggestionHighlighted: "react-autosuggest__suggestion--highlighted",
      sectionContainer: "react-autosuggest__section-container",
      sectionContainerFirst: "react-autosuggest__section-container--first",
      sectionTitle: "react-autosuggest__section-title"
    };
  };

  render() {
    const styles = reactCSS(
      {
        default: {
          field: {
            display: "inline-block",
            width: this.props.fullWidth ? "100%" : "256px",
            padding: 0,
            boxSizing: "border-box"
          }
        }
      },
      this.props,
      this.state
    );
    return (
      <div className="autocomplete" style={styles.field}>
        <Autosuggest
          id={this.props.label}
          suggestions={this.state.suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getSuggestionValue}
          renderSuggestion={this.renderSuggestion}
          renderInputComponent={this.renderInputComponent}
          onSuggestionSelected={this.onSuggestionSelected}
          theme={this.theme()}
          inputProps={this.inputProps()}
          alwaysRenderSuggestions={this.state.renderSuggestions}
          highlightFirstSuggestion={true}
        />
      </div>
    );
  }
}

export default AutoComplete;



// WEBPACK FOOTER //
// ./src/components/support/auto-complete/index.jsx